<template>
  <el-form class="settings"
           label-position="top" :model="param" status-icon ref="layoutSettingsForm" label-width="100px">
    <el-form-item>
      <span slot="label" class="span-box">
          <span>{{ $t('settings.cm') }}</span>
          <el-tooltip style="diaplay:inline" effect="dark" :content="$t('settings.cmTips')" placement="top">
            <i class="el-icon-question"/>
          </el-tooltip>
      </span>
      <el-slider
        style="margin-left: 15px"
        :max="300"
        :min="30"
        v-model="param.cm"
        show-input>
      </el-slider>
    </el-form-item>
    <el-form-item class="settings-normal-range-content" :label="$t('settings.fhrRange')">
      <div style="display: flex;">
        <el-slider
          class="settings-normal-range-slider"
          v-model="param.normalRange"
          range
          show-tooltip
          show-stops
          label
          :max="210"
          :step="10"
          :min="60"
          :marks="config.normalRangeMarks">
        </el-slider>
        <el-input
          class="settings-normal-range-text"
          :value="param.normalRange[0] + '~' + param.normalRange[1]"
          :disabled="true">
        </el-input>
      </div>
    </el-form-item>
    <el-form-item class="settings-radio-content" :label="$t('settings.speed')">
      <el-radio-group v-model="param.speed" size="medium" class="settings-radio-group">
        <el-radio border class="settings-radio-speed" :label="1">1cm/min</el-radio>
        <el-radio border class="settings-radio-speed" :label="2">2cm/min</el-radio>
        <el-radio border class="settings-radio-speed" :label="3">3cm/min</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item class="settings-radio-content" :label="$t('settings.fhr')">
      <el-radio-group v-model="param.fhrRange" size="medium" class="settings-radio-group">
        <el-radio border class="settings-radio-fhr-range" :label="1">
          {{ config.fhrRange.remind.gb }}
        </el-radio>
        <el-radio border class="settings-radio-fhr-range" :label="2">
          {{ config.fhrRange.remind.abell }}
        </el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item class="settings-radio-content">
      <span slot="label" class="span-box">
          <span>{{ $t('settings.bed') }}</span>
          <el-tooltip style="diaplay:inline" effect="dark" :content="$t('settings.bedTips')" placement="top">
            <i class="el-icon-question"/>
          </el-tooltip>
      </span>
      <el-radio-group v-model="param.bedMode" size="medium" class="settings-radio-group">
        <div v-for="(item, index) in config.beds"
             :key="index">
          <el-radio border :label="item" class="settings-radio-bed"></el-radio>
        </div>
      </el-radio-group>
    </el-form-item>

    <el-form-item class="settings-radio-content">
      <span slot="label" class="span-box">
          <span>{{ $t('settings.alarmSet') }}</span>
      </span>
      <el-switch
        v-model="param.alarm.fhrRange"
        :active-text="$t('settings.fhrAlarm')">
      </el-switch>
    </el-form-item>

    <el-form-item class="settings-save">
      <el-button type="primary" @click="save">{{ $t('settings.save') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Global from '../common/defines'
import SettingStorage from '../common/setting-storage'

export default {
  name: 'Settings',
  data () {
    return {
      config: {
        normalRangeMarks: {
          0: '0°C',
          8: '8°C',
          37: '37°C',
          50: {
            style: {
              color: '#1989FA'
            },
            label: this.$createElement('strong', '50%')
          }
        },
        beds: [1, 2, 4, 8, 16],
        fhrRange: {
          remind: {
            gb: '',
            abell: ''
          }
        }
      },
      param: null
    }
  },
  watch: {},
  created () {
    this.param = SettingStorage.get()
  },
  mounted () {
    this.config.fhrRange.remind.gb = Global.fhrRange.gb.min + 'bpm~' + Global.fhrRange.gb.max + 'bpm'
    this.config.fhrRange.remind.abell = Global.fhrRange.abell.min + 'bpm~' + Global.fhrRange.abell.max + 'bpm'
  },
  methods: {
    save () {
      let fhrMax, fhrMin
      if (this.param.fhrRange === 2 || this.param.bedMode >= 8) {
        fhrMax = Global.fhrRange.abell.max
        fhrMin = Global.fhrRange.abell.min
      } else if (this.param.fhrRange === 1) {
        fhrMax = Global.fhrRange.gb.max
        fhrMin = Global.fhrRange.gb.min
      }
      SettingStorage.save(this.param)
      const tmp = {
        cm: this.param.cm,
        speed: this.param.speed,
        fhrNormalMin: this.param.normalRange[0],
        fhrNormalMax: this.param.normalRange[1],
        bedMode: this.param.bedMode,
        fhrMax: fhrMax,
        fhrMin: fhrMin,
        alarm: {
          fhrRange: this.param.alarm.fhrRange
        }

      }
      this.$emit('saveSettings', JSON.parse(JSON.stringify(tmp)))

      this.$message({
        message: this.$t('settings.saveSuccess'),
        type: 'success'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body, div {
  margin: 0;
  padding: 0;
  border: 0;
}

.settings {
  background: #fff;
  width: 100%;
  height: 100%;

  padding: 0px 20px 0px 20px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
}

.settings-radio-group {
  display: flex;
  flex-wrap: wrap;
}

.settings-radio-speed {
  margin: 10px 10px 0 0;
  width: 100px;
}

.settings-radio-fhr-range {
  margin: 10px 10px 0 0;
  width: 160px;
}

.settings-radio-bed {
  margin: 10px 10px 0 0;
  width: 75px;
}

.settings-normal-range-slider {
  margin: 0 30px 25px 15px;
  flex: 1;
}

.settings-normal-range-text {
  width: 130px;
}

.settings-save {
  margin-top: 20px;
  text-align: center
}
</style>
<style>
.settings-radio-content .el-form-item__label {
  float: none;
  display: inline-block;
  text-align: left;
  padding: 0;
  line-height: 20px;
  margin-top: 20px;
}

.settings-radio-content .el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0;
}

.settings .el-input__inner {
  height: 32px;
  line-height: 32px;
}

.settings-normal-range-text .el-input__inner {
  text-align: center;
}
</style>
